// extracted by mini-css-extract-plugin
export default {"root":"TextEditor_root__BOGEr","editor":"TextEditor_editor__Cqtq6","label":"TextEditor_label__5TdoF","isRequired":"TextEditor_isRequired__8wCMd"};